import { render, staticRenderFns } from "./PaymentOrders.vue?vue&type=template&id=2787ab4c&scoped=true&"
import script from "./PaymentOrders.vue?vue&type=script&lang=js&"
export * from "./PaymentOrders.vue?vue&type=script&lang=js&"
import style0 from "./PaymentOrders.vue?vue&type=style&index=0&id=2787ab4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2787ab4c",
  null
  
)

export default component.exports